export default __webpack_public_path__ + "static/media/slide1.14619b04.webp";